/**
 * Copy for the Aquarist page.
 *
 * The titles are the three verbs from the page headline, in the same order, so
 * the headline reads as a contents list for what follows. Kept to the features
 * the app actually ships — the same nouns the privacy policy declares (logged
 * aquariums, planned aquariums, water readings, journals, planners) — so the
 * site never describes more than the app does.
 */
export type AquaristFeature = {
  title: string;
  body: string;
};

export const AQUARIST_FEATURES: AquaristFeature[] = [
  {
    title: 'Track your aquariums',
    body: 'Keep track of every tank. Log water parameters, write a journal for each aquarium, and set reminders for routine maintenance.',
  },
  {
    title: 'Plan a new aquarium',
    body: 'Plan your next tank before you set it up. Work through your equipment, livestock and setup, and keep your plans organised alongside your existing aquariums.',
  },
  {
    title: 'Research the hobby',
    body: 'Explore fishkeeping beyond your own tanks. Read articles covering everything from getting started and species spotlights to the travel and lifestyle side of the hobby.',
  },
];
